import { lazy, Suspense } from 'react';

const PdpRespExitModalLazyComponent = lazy(() =>
    import(/* webpackChunkName: "PdpRespExitModal" */ './PdpRespExitModal')
);

export const PdpRespExitModalLazy = props => (
    <Suspense fallback="">
        <PdpRespExitModalLazyComponent {...props} />
    </Suspense>
);
